import ApiService from './_api.service'

const SIMULATIONS_URL = '/v1/simulations/'

const SimulationService = {
    read: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(
                    key => (queryParams += key + '=' + args[key] + '&')
                )
        }
        return ApiService.get(SIMULATIONS_URL + queryParams)
    },

    canSimulate: function(id) {
        return ApiService.get(SIMULATIONS_URL + 'can/simulate/' + id)
    },

    readById: function(id) {
        if (!id) return

        return ApiService.get(SIMULATIONS_URL + id)
    },

    readTCvsPVDs: function(id) {
        if (!id) return

        return ApiService.get(SIMULATIONS_URL + id + '/tcpvds/')
    },

    readAssortmentAnalysisById: function(id) {
        if (!id) return

        return ApiService.get(SIMULATIONS_URL + id + '/assortment-analysis/')
    },

    createClone: function(id) {
        if (!id) return

        return ApiService.post(SIMULATIONS_URL + id + '/clone/')
    },

    removeClone: function(id) {
        if (!id) return

        return ApiService.delete(SIMULATIONS_URL + id + '/remove-clone/')
    },

    copyBranchParameters: function(id, similarProduct, branchIds) {
        let data = new FormData()

        data.set('similar_product', similarProduct)
        data.set('branch_ids', branchIds)

        return ApiService.post(
            SIMULATIONS_URL + id + '/copy-branch-parameters/',
            data
        )
    },
    copyDcParameters: function(id, similarProduct, branchIds) {
        let data = new FormData()

        data.set('similar_product', similarProduct)
        data.set('branch_ids', branchIds)

        return ApiService.post(
            SIMULATIONS_URL + id + '/copy-dc-parameters/',
            data
        )
    },

    execute: function(id, observation) {
        if (!id) return

        let data = new FormData()

        data.set('observation', observation)

        return ApiService.post(SIMULATIONS_URL + id + '/execute/', data)
    },

    approve: function(id, caveat) {
        if (!id) return
        let data = new FormData()

        data.set('caveat', caveat)

        return ApiService.post(SIMULATIONS_URL + id + '/approve/', data)
    }
}

export default SimulationService
export { SimulationService }
